export default {
  id: 'completed',
  navTitleID: 'intro.navTitle',
  hideheader: true,
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'empty',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text3'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text4'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text5'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text6'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text7'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text8'
            }
          ]
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: true,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-3',
              feedbackTextID: 'option-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: false,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            },
            {
              isCorrect: true,
              textID: 'option-3',
              feedbackTextID: 'option-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: false,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: true,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-3',
              feedbackTextID: 'option-3-feedback'
            }
          ]
        }
      ]
    }

  ]
}
